import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage } from '../../../dsl/front';
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let ContactLocationTabUI = class ContactLocationTabUI extends Vue {
};
__decorate([
    Prop({ type: String, required: true })
], ContactLocationTabUI.prototype, "location", void 0);
ContactLocationTabUI = __decorate([
    Component({
        name: 'ContactLocationTabUI',
        components: {
            BootstrapImage
        },
        template: `
    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="contact__location">
            <iframe :src="location" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </section>
  `
    })
], ContactLocationTabUI);
export { ContactLocationTabUI };
